import React, { useState, useEffect, useRef } from 'react';
import { cn } from '../../lib/utils';

const DropdownMenu = ({
  trigger,
  items,
  className,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const dropdownClasses = cn(
    'relative inline-block text-left',
    className
  );

  const menuClasses = cn(
    'absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-50',
    !isOpen && 'hidden'
  );

  const itemClasses = 'text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm hover:bg-gray-100 cursor-pointer';

  return (
    <div className={dropdownClasses} ref={dropdownRef} {...props}>
      <div onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}>
        {trigger}
      </div>
      {isOpen && (
        <div className={menuClasses}>
          <div className="py-1">
            {items.map((item, index) => (
              <div
                key={index}
                className={itemClasses}
                onClick={(e) => {
                  e.stopPropagation();
                  item.onClick && item.onClick();
                  setIsOpen(false);
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

DropdownMenu.displayName = 'DropdownMenu';

export default DropdownMenu;
